import * as amplitude from '@amplitude/analytics-browser'
import { APP_NAME, APP_VERSION, ENV_CONFIG } from '@/constants/envs/constants'

export const initAmplitude = () => {
  amplitude.init(ENV_CONFIG.amplitudeApiKey, {
    instanceName: APP_NAME,
    appVersion: APP_VERSION,
    defaultTracking: true
  })
}

export function identifyUser(userId: string | undefined) {
  if (userId) {
    amplitude.setUserId(userId)
  } else {
    amplitude.setUserId(null as any)
  }
}

export async function setUserProperty(property: string, value: string) {
  const identifyObj = new amplitude.Identify()
  identifyObj.set(property, value)
  await amplitude.identify(identifyObj).promise
}
